<template>
  <div>
    <b-card class="custom-card mb-2">
      <h6 class="text-muted text-small">ВНЕШНИЕ КОНТАКТЫ</h6>
      <div class="page-body">
        <template v-if="isBusy || (externalItems && externalItems.length > 0)">
          <div class="page-table-container">
            <b-table
              id="location-contacts"
              class="custom-table mb-0"
              :busy.sync="isBusy"
              :items="externalItems"
              :fields="fields"
              :current-page="externalCurrentPage"
              :per-page="perPage"
              no-provider-filtering
              no-provider-paging
              no-provider-sorting
            >
              <template #table-busy>
                <div class="text-center text-success my-2">
                  <b-spinner class="align-middle"/>
                  <strong>Загрузка</strong>
                </div>
              </template>

              <template #cell(name)="row">
                <b-form-input
                  id="input_name"
                  size="sm"
                  :disabled="isDisabled"
                  autocomplete="off"
                  v-model="row.item.name"
                />
              </template>

              <template #cell(job_title)="row">
                <b-form-input
                  id="input_job_title"
                  size="sm"
                  :disabled="isDisabled"
                  autocomplete="off"
                  v-model="row.item.job_title"
                />
              </template>

              <template #cell(phone_number)="row">
                <b-input-group size="sm" prepend="+7">
                  <b-form-input
                    id="input_phone_number"
                    type="tel"
                    size="sm"
                    :disabled="isDisabled"
                    autocomplete="off"
                    :placeholder="$t('message.customers.modal.phonePlaceholder')"
                    :state="contactPhoneState(row.item.phone_number)"
                    :formatter="phoneNationalNumber"
                    :value="phoneNationalNumber(row.item.phone_number)"
                    @input="row.item.phone_number = $event"
                  />
                  <b-form-invalid-feedback :state="contactPhoneState(row.item.phone_number)">
                    После +7 введите 10 цифр.
                  </b-form-invalid-feedback>
                </b-input-group>
              </template>

              <template #cell(email)="row">
                <b-form-input
                  size="sm"
                  :disabled="isDisabled"
                  autocomplete="off"
                  v-model="row.item.email"
                />
              </template>

              <template #cell(comment)="row">
                <b-form-input
                  id="input_comment"
                  size="sm"
                  :disabled="isDisabled"
                  autocomplete="off"
                  v-model="row.item.note"
                />
              </template>

              <template #head(action)="row">
                <b-btn v-if="canEditLocations()" variant="link" style="color: #1A9167 !important; text-decoration: none !important;" :disabled="isDisabled" @click.stop="onAdd(false)">
                  <v-icon name="buttons/plus" :size="12" class="mr-1"/>
                  Добавить
                </b-btn>
              </template>

              <template #cell(action)="row">
                <b-button variant="link" @click="onRemove(row, false)" :disabled="isDisabled">
                  <v-icon name="buttons/trash" :size="16"/>
                </b-button>
              </template>
            </b-table>
          </div>

          <div class="page-pagination">
            <pagination-footer
              :total-rows="externalItems.length"
              :per-page="perPage"
              :current-page.sync="externalCurrentPage"
              @per-page-change="val => onPerPageChange(val, 'externalCurrentPage')"
            />
          </div>
        </template>

        <div v-else class="empty-state-container">
          <v-icon name="navbar/empty_table" :size="90"/>
          <h5>Нет внешних контактов.</h5>
          <p>Добавьте контакты прямо сейчас</p>
          <b-btn v-if="canEditLocations()" class="custom-btn-primary mt-1" :disabled="isDisabled" @click.stop="onAdd(false)">
            <v-icon name="buttons/plus" :size="12" class="mr-1"/>
            Новый контакт
          </b-btn>
        </div>
      </div>
    </b-card>

    <b-card class="custom-card">
      <h6 class="text-muted text-small">ВНУТРЕННИЕ КОНТАКТЫ</h6>
      <div class="page-body">
        <template v-if="isBusy || (internalItems && internalItems.length > 0)">
          <div class="page-table-container">
            <b-table
              id="location-contacts"
              class="custom-table mb-0"
              :busy.sync="isBusy"
              :items="internalItems"
              :fields="fields"
              :current-page="internalCurrentPage"
              :per-page="perPage"
              no-provider-filtering
              no-provider-paging
              no-provider-sorting
            >
              <template #table-busy>
                <div class="text-center text-success my-2">
                  <b-spinner class="align-middle"/>
                </div>
              </template>

              <template #cell(name)="row">
                <b-form-input
                  size="sm"
                  :disabled="isDisabled"
                  autocomplete="off"
                  v-model="row.item.name"
                />
              </template>

              <template #cell(job_title)="row">
                <b-form-input
                  size="sm"
                  :disabled="isDisabled"
                  autocomplete="off"
                  v-model="row.item.job_title"
                />
              </template>

              <template #cell(phone_number)="row">
                <b-input-group size="sm" prepend="+7">
                  <b-form-input
                    type="tel"
                    size="sm"
                    :disabled="isDisabled"
                    autocomplete="off"
                    :placeholder="$t('message.customers.modal.phonePlaceholder')"
                    :state="contactPhoneState(row.item.phone_number)"
                    :formatter="phoneNationalNumber"
                    :value="phoneNationalNumber(row.item.phone_number)"
                    @input="row.item.phone_number = $event"
                  />
                  <b-form-invalid-feedback :state="contactPhoneState(row.item.phone_number)">
                    После +7 введите 10 цифр.
                  </b-form-invalid-feedback>
                </b-input-group>
              </template>

              <template #cell(email)="row">
                <b-form-input
                  size="sm"
                  :disabled="isDisabled"
                  autocomplete="off"
                  v-model="row.item.email"
                />
              </template>

              <template #cell(comment)="row">
                <b-form-input
                  size="sm"
                  :disabled="isDisabled"
                  autocomplete="off"
                  v-model="row.item.note"
                />
              </template>

              <template #head(action)="row">
                <b-btn v-if="canEditLocations()" variant="link" style="color: #1A9167 !important; text-decoration: none !important;" :disabled="isDisabled" @click.stop="onAdd(true)">
                  <v-icon name="buttons/plus" :size="12" class="mr-1"/>
                  Добавить
                </b-btn>
              </template>

              <template #cell(action)="row">
                <b-button variant="link" @click="onRemove(row, true)" :disabled="isDisabled">
                  <v-icon name="buttons/trash" :size="16"/>
                </b-button>
              </template>
            </b-table>
          </div>

          <div class="page-pagination">
            <pagination-footer
              :total-rows="internalItems.length"
              :per-page="perPage"
              :current-page.sync="internalCurrentPage"
              @per-page-change="val => onPerPageChange(val, 'internalCurrentPage')"
            />
          </div>
        </template>

        <div v-else class="empty-state-container">
          <v-icon name="navbar/empty_table" :size="90"/>
          <h5>Нет внутренних контактов.</h5>
          <p>Добавьте контакты прямо сейчас</p>
          <b-btn v-if="canEditLocations()" class="custom-btn-primary mt-1" :disabled="isDisabled" @click.stop="onAdd(true)">
            <v-icon name="buttons/plus" :size="12" class="mr-1"/>
            Новый контакт
          </b-btn>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import locations from "../../network/locations";
  import helpers from "../../utilites/helpers";
  import permissions, {PERM} from "../../utilites/permissions";
import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";

export default {
  name: "LocationContacts",
  components: {PaginationFooter},
  mixins: [
    locations,
    helpers, permissions
  ],
  props: {
    isDisabled: Boolean
  },
  data() {
    return {
      locationId: 0,
      isBusy: false,
      externalItems: [],
      internalItems: [],
      perPage: 10,
      externalCurrentPage: 1,
      internalCurrentPage: 1,
      fields: [
        {
          key: 'name',
          label: 'ФИО',
        },
        {
          key: 'job_title',
          label: 'Должность',
        },
        {
          key: 'phone_number',
          label: 'Телефон',
        },
        {
          key: 'email',
          label: 'Email'
        },
        {
          key: 'comment',
          label: 'Комментарий',
        },
        {
          key: 'action',
          label: "Действия",
          class: 'location-contacts-action',
        },
      ],
    }
  },
  methods: {
    configure(locationId) {
      this.locationId = locationId;
      this.getItems();
    },
    async getItems() {
      this.isBusy = true;
      const result = await this.getLocationContactsById(this.locationId);
      this.isBusy = false;

      if (result.data == null) return;

      this.externalItems = result.data.items.filter(item => !item.is_internal);
      this.internalItems = result.data.items.filter(item => item.is_internal);
    },
    onAdd(isInternal) {
      const data = {
        id: 0,
        name: '',
        job_title: '',
        phone_number: '',
        email: '',
        note: '',
        is_internal: isInternal
      };

      if (isInternal) {
        this.internalItems.push(data);
        if (!this.isInternalExpanded) this.isInternalExpanded = true;
      } else {
        this.externalItems.push(data);
        if (!this.isExternalExpanded) this.isExternalExpanded = true;
      }
    },
    onRemove(row, isInternal) {
      if (row.item) {
        this.deleteRow = row.item;
      }

      const title = "Удаление контакта";
      const message = `Вы уверены, что хотите удалить контакт ${this.deleteRow.name || 'без имени'}?`;
      this.showModalDelete(title, message,() => {
        const currentPage = isInternal ? this.internalCurrentPage : this.externalCurrentPage;
        const index = ((currentPage  - 1) * this.perPage) + row.index;

        if (isInternal) {
          this.internalItems.splice(index, 1);
        } else {
          this.externalItems.splice(index, 1);
        }
      });
    },
    validateContacts() {
      for (const [items, label] of [[this.externalItems, 'внешних'], [this.internalItems, 'внутренних']]) {
        const index = items.findIndex(contact => this.contactPhoneState(contact.phone_number) === false);
        if (index !== -1) {
          this.showSubmitError(`Во ${label} контактах, строка №${index + 1}, укажите телефон: +7 и 10 цифр.`);
          return false;
        }
      }
      return true;
    },
    async saveContacts(locationId) {
      if (!this.validateContacts()) {
        return { error: { message: 'Некорректный номер телефона контакта.' } };
      }
      const allContacts = [...this.externalItems, ...this.internalItems];
      return await this.postLocationContacts(allContacts, locationId);
    },
    onPerPageChange(newPerPage, currentPageField) {
      this.perPage = Number(newPerPage);
      this[currentPageField] = 1;
    },
    // Permissions
    canEditLocations() {
      return this.hasPermission([PERM.LOCATION_EDIT]);
    },
  }
}
</script>

<style>
#location-contacts td {
  text-align: center;
}

#location-contacts th {
  text-align: center;
  vertical-align: middle;
}

.location-contacts-action {
  width: 135px;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationContacts.vue